export const EVENT_CREATE_SANDBOX_PATH = "/local-debug/paid-event-creation";

export function isEventCreateSandboxLocation() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return ["localhost", "127.0.0.1", "[::1]"].includes(host)
    && window.location.pathname === EVENT_CREATE_SANDBOX_PATH;
}

export const sandboxHostRating = Object.freeze({
  has_paid_host_events_access: true,
  max_participants_limit: 100,
  hard_max_participants_limit: 100,
  host_paid_max_participants_limit: 100,
  has_unlimited_event_capacity: true,
  capacity_mode: "host_paid",
});

export const sandboxOrganizerPanel = Object.freeze({
  summary: sandboxHostRating,
  paid_host_access_request: { status: "approved" },
  paid_host_agreement: { accepted: true },
  stripe: { can_accept_paid_events: true },
  payments_summary: {},
  recent_events: [],
});
